import { render } from "./DeleteQuestionnaire.vue?vue&type=template&id=308e0f32&scoped=true"
import script from "./DeleteQuestionnaire.vue?vue&type=script&lang=js"
export * from "./DeleteQuestionnaire.vue?vue&type=script&lang=js"

import "./DeleteQuestionnaire.vue?vue&type=style&index=0&id=308e0f32&scoped=true&lang=less"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-308e0f32"]])

export default __exports__